import {createRouter, createWebHashHistory} from 'vue-router';
import main from '../components/MobileMain.vue';
import MyPage from '../components/MyPage.vue';
import about from '../components/About.vue';
import sightseeingTour from '../components/SightseeingTour.vue';
import order from '../components/PlaceAnOrder.vue';
import credits from '../components/CreditsExchange.vue';
import vip from '../components/JoinVip.vue';
import organizeActivity from '../components/OrganizeActivity.vue';
import traceBarCode from '../components/TraceBarCode.vue';


const routes = [
    {path: '/', component: main, meta: {title: '黄金梨优享汇'}},
    {path: '/SightseeingTour', component: sightseeingTour, meta: {title: '文旅'}},
    {path: '/Main', component: main, meta: {title: '黄金梨优享汇'}},
    {path: '/MyPage', component: MyPage, meta: {title: '我的'}},
    {path: '/About', component: about, meta: {title: '关于'}},
    {path: '/Order', component: order, meta: {title: '下单'}},
    {path: '/Credits', component: credits, meta: {title: '积分兑换'}},
    {path: '/Vip', component: vip, meta: {title: '加入会员'}},
    {path: '/OrganizeActivity', component: organizeActivity, meta: {title: '特色活动'}},
    {path: '/TraceBarCode', component: traceBarCode, meta: {title: '一树一码'}},
    // 可以添加更多路由...
];

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL), // 打包APP必须使用createWebHashHistory
    // history: createWebHistory(process.env.BASE_URL), // 使用 HTML5 历史模式
    routes,
});

router.beforeEach((to, from, next) => {
    // 如果当前路由配置了 meta.title，则使用该标题
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        // 未配置标题时，可设置一个默认标题（或留空）
        document.title = '博望金梨'
    }
    next() // 必须调用 next() 才能继续跳转
})

export default router;